import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RecruitmentStatsComponent } from "./pages/recruitment-stats/recruitment-stats.component";
import { UtilsService } from "app/auth/service/utils.service";
import recruitmentMenu from "../recruitment.menu";
import { RouterModule } from "@angular/router";
import { locale as statsIt } from "./i18n/stats.lang-it";
import statsRoutes from "./stats.routes";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { ExtendedModule } from "@angular/flex-layout";
import { CoreCardModule } from "@core/components/core-card/core-card.module";
import { AngularEditorModule } from "@kolkov/angular-editor";
import { NgbTooltipModule, NgbTimepickerModule, NgbDropdownModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule } from "@ngx-translate/core";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { BreadcrumbModule } from "app/layout/components/content-header/breadcrumb/breadcrumb.module";
import { ContentHeaderModule } from "app/layout/components/content-header/content-header.module";
import { LayoutModule } from "app/layout/layout.module";
import { Ng2FlatpickrModule } from "ng2-flatpickr";
import { NgApexchartsModule } from "ng-apexcharts";
import { CoreCommonModule } from "@core/common.module";
import { StepCounterComponent } from './components/step-counter.component';
import CommercialStatsComponent from "./pages/commercial-stats/commercial-stats.component";

@NgModule({
  declarations: [RecruitmentStatsComponent, StepCounterComponent, CommercialStatsComponent],
  imports: [
    RouterModule.forChild(statsRoutes),
    CommonModule,
    NgSelectModule,
    CommonModule,
    ContentHeaderModule,
    TranslateModule,
    ExtendedModule,
    Ng2FlatpickrModule,
    NgxDatatableModule,
    LayoutModule,
    CoreCardModule,
    AngularEditorModule,
    NgbTooltipModule,
    BreadcrumbModule,
    DragDropModule,
    NgbTimepickerModule,
    NgbDropdownModule,
    NgApexchartsModule,
    CoreCommonModule,
  ],
})
export class StatsModule {
  constructor(private _utils: UtilsService) {
    this._utils.initModule("stats", statsIt, recruitmentMenu, []);
  }
}
